import React, { useState } from "react";
import { Redirect } from "react-router-dom";
import { useTranslation } from "react-i18next";
// Redux
import { useSelector, useDispatch } from "react-redux";
import { clinicianLogout } from "../../redux/clinicianDucks";
// Constants
import { pathHomePage } from "../../config/constants";
// Components
import {
  HeaderContainer,
  Menu,
  BtnShowMenu,
  BtnShowMenuResponsive,
  CloseImg,
  ResponsiveMenu,
  ResponsiveNavigation,
  RespBtnLogout,
  Navigation,
  ShowHospitalDiv,
  HospitalText,
  LngLogoutContainer,
  BtnLogout,
} from "./styles";
import Translations from "../translations";
import ButtonWithIcon from "../buttonWithIcon";
import ProjectVersion from "../projectVersion";
// Assets
import btnClose from "../../assets/btn_close.svg";
import IcoAvatar from "../../assets/ico_link_avatar.svg";
import IcoSettings from "../../assets/ico_link_settings.svg";

const Header = () => {
  const [showMenu, setShowMenu] = useState(false);
  const [redirect, setRedirect] = useState(false);

  const [t] = useTranslation("global");
  const dispatch = useDispatch();
  const clinicianData = useSelector(({ clinician }) => clinician.data);

  const handleRenderLinks = () => {
    return (
      <>
        <ButtonWithIcon
          icon={IcoAvatar}
          name={t("header.PatientsButton")}
          path={`${pathHomePage}/home/${clinicianData.token}`}
          margin="0 5px 0 0"
        />
        <ButtonWithIcon
          icon={IcoSettings}
          name={t("header.settingsButton")}
          path={`${pathHomePage}/settings/${clinicianData.token}`}
          margin="0 5px 0 0"
        />
      </>
    );
  };

  const handleLogout = (e) => {
    e.preventDefault();
    dispatch(clinicianLogout());
    setRedirect(true);
  };
  if (redirect) {
    return <Redirect to={`${pathHomePage}`} />;
  }

  const handleShowMenu = (e) => {
    e.preventDefault();
    setShowMenu(!showMenu);
  };

  return (
    <HeaderContainer>
      <Menu>
        <BtnShowMenu onClick={handleShowMenu} />
        {showMenu && (
          <ResponsiveMenu>
            <BtnShowMenuResponsive onClick={handleShowMenu}>
              <CloseImg src={btnClose} alt="close-btn" />
            </BtnShowMenuResponsive>
            <ShowHospitalDiv active>
              <HospitalText>{clinicianData.HOSPITAL_NAME}</HospitalText>
            </ShowHospitalDiv>
            <ResponsiveNavigation>
              {handleRenderLinks()}
              <RespBtnLogout onClick={handleLogout}>{t("header.logoutButton")}</RespBtnLogout>
            </ResponsiveNavigation>
          </ResponsiveMenu>
        )}
        <Navigation>
          {handleRenderLinks()}
          <ShowHospitalDiv>
            <HospitalText>{clinicianData.HOSPITAL_NAME}</HospitalText>
          </ShowHospitalDiv>
        </Navigation>

        <LngLogoutContainer>
          <Translations />
          <BtnLogout onClick={handleLogout}>{t("header.logoutButton")}</BtnLogout>
        </LngLogoutContainer>
      </Menu>
      <ProjectVersion />
    </HeaderContainer>
  );
};

export default Header;
